export enum ViewMode {
  Content,
  Label,
  Tools,
  Search,
  Help,
  NodeInfo,
  LabelInfo
}
